import { render, staticRenderFns } from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=template&id=059feeff&scoped=true"
import script from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=script&lang=js"
export * from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=script&lang=js"
import style0 from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=style&index=0&id=059feeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059feeff",
  null
  
)

export default component.exports